<div
    class="relative z-10"
    aria-labelledby="slide-over-title"
    role="dialog"
    aria-modal="true"
>
    <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ease-in-out duration-500"
        [ngClass]="visible ? 'visible opacity-100' : 'invisible opacity-0'"
    ></div>

    <div
        class="fixed inset-0 overflow-hidden overlay-container"
        [ngClass]="visible ? 'visible' : 'invisible'"
    >
        <div class="absolute inset-0 overflow-hidden" #overlay>
            <div
                class="pointer-events-none fixed inset-y-0 left-0 flex max-w-full"
            >
                <div
                    class="pointer-events-auto w-screen transform transition ease-in-out duration-300"
                    [ngClass]="{
                        '-translate-x-full': !visible,
                        'translate-x-0': visible,
                    }"
                >
                    <div
                        class="flex h-full max-h-screen min-h-0 flex-col bg-white shadow-xl"
                    >
                        <div
                            class="flex min-h-0 flex-1 flex-col overflow-y-auto overscroll-y-contain py-6 px-4 sm:px-6"
                        >
                            <div class="flex items-center justify-between px-4">
                                <a
                                    [routerLink]="['/']"
                                    class="logo-link ml-3 mb-3"
                                    (click)="close()"
                                >
                                    <img
                                        src="assets/cube-logo-small.webp"
                                        class="logo"
                                        alt="Industore Storefront"
                                    />
                                </a>
                                <button class="btn" (click)="close()">
                                    <fa-icon
                                        icon="times"
                                        class="text-gray-400"
                                    ></fa-icon>
                                </button>
                            </div>

                            <!-- Language: first item in mobile nav -->
                            <div
                                class="mb-4 border-b border-gray-200 px-4 pb-4"
                                role="group"
                                [attr.aria-label]="
                                    'account.languages' | translate
                                "
                            >
                                <p
                                    class="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500"
                                >
                                    {{ "account.languages" | translate }}
                                </p>
                                <div
                                    class="flex items-center rounded-lg border border-gray-200 p-0.5 text-sm font-semibold"
                                >
                                    <button
                                        type="button"
                                        (click)="setLanguage('en')"
                                        class="flex-1 rounded-md px-3 py-2 transition-colors"
                                        [class.bg-primary]="
                                            languageService.currentLanguage ===
                                            'en'
                                        "
                                        [class.text-white]="
                                            languageService.currentLanguage ===
                                            'en'
                                        "
                                        [class.text-body]="
                                            languageService.currentLanguage !==
                                            'en'
                                        "
                                    >
                                        {{ "language.english" | translate }}
                                    </button>
                                    <button
                                        type="button"
                                        (click)="setLanguage('ar')"
                                        class="flex-1 rounded-md px-3 py-2 transition-colors"
                                        [class.bg-primary]="
                                            languageService.currentLanguage ===
                                            'ar'
                                        "
                                        [class.text-white]="
                                            languageService.currentLanguage ===
                                            'ar'
                                        "
                                        [class.text-body]="
                                            languageService.currentLanguage !==
                                            'ar'
                                        "
                                    >
                                        {{ "language.arabic" | translate }}
                                    </button>
                                </div>
                            </div>

                            <!-- Currency -->
                            <div
                                class="mb-4 border-b border-gray-200 px-4 pb-4"
                                role="group"
                                [attr.aria-label]="
                                    'account.currency' | translate
                                "
                            >
                                <p
                                    class="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500"
                                >
                                    {{ "account.currency" | translate }}
                                </p>
                                <div
                                    class="flex items-center rounded-lg border border-gray-200 p-0.5 text-sm font-semibold"
                                >
                                    <button
                                        type="button"
                                        (click)="setCurrency('USD')"
                                        class="flex-1 rounded-md px-3 py-2 transition-colors"
                                        [class.bg-primary]="
                                            currencyService.currentCurrency ===
                                            'USD'
                                        "
                                        [class.text-white]="
                                            currencyService.currentCurrency ===
                                            'USD'
                                        "
                                        [class.text-body]="
                                            currencyService.currentCurrency !==
                                            'USD'
                                        "
                                    >
                                        {{ "currency.usd" | translate }}
                                    </button>
                                    <button
                                        *ngIf="sypAvailable$ | async"
                                        type="button"
                                        (click)="setCurrency('SYP')"
                                        class="flex-1 rounded-md px-3 py-2 transition-colors"
                                        [class.bg-primary]="
                                            currencyService.currentCurrency ===
                                            'SYP'
                                        "
                                        [class.text-white]="
                                            currencyService.currentCurrency ===
                                            'SYP'
                                        "
                                        [class.text-body]="
                                            currencyService.currentCurrency !==
                                            'SYP'
                                        "
                                    >
                                        {{ "currency.syp" | translate }}
                                    </button>
                                </div>
                            </div>

                            <ul
                                class=""
                                *ngIf="collectionTree$ | async as tree"
                            >
                                <li
                                    class=""
                                    *ngFor="let collection of tree.children"
                                >
                                    <a
                                        class="block cursor-pointer w-full text-gray-600 hover:bg-gray-50 hover:text-gray-900 group items-center px-3 py-2 font-medium rounded-md"
                                        (click)="onL0Click($event, collection)"
                                        >{{ collection.name }}</a
                                    >
                                    <ul
                                        *ngIf="collection.children.length"
                                        [ngClass]="
                                            selected0 === collection.id
                                                ? 'block'
                                                : 'hidden'
                                        "
                                    >
                                        <li
                                            class="level1"
                                            *ngFor="
                                                let level1 of collection.children
                                            "
                                        >
                                            <a
                                                class="block cursor-pointer w-full pl-8 text-gray-600 hover:bg-gray-50 hover:text-gray-900 group items-center px-3 py-2 font-medium rounded-md"
                                                (click)="
                                                    onL1Click($event, level1)
                                                "
                                                >{{ level1.name }}</a
                                            >
                                            <ul
                                                *ngIf="level1.children.length"
                                                class="expandable"
                                                [class.expanded]="
                                                    selected1 === level1.id
                                                "
                                            >
                                                <li
                                                    class="level2"
                                                    *ngFor="
                                                        let level2 of level1.children
                                                    "
                                                >
                                                    <a
                                                        class=""
                                                        (click)="close()"
                                                        [routerLink]="[
                                                            '/category',
                                                            level2.slug,
                                                        ]"
                                                        >{{ level2.name }}</a
                                                    >
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>

                            <!-- Sectors -->
                            <ng-container
                                *ngIf="sectorCollections$ | async as sectors"
                            >
                                <div
                                    *ngIf="sectors.length"
                                    class="mt-4 border-t border-gray-200 pt-4"
                                >
                                    <h3
                                        class="px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ "nav.sectors" | translate }}
                                    </h3>
                                    <ul>
                                        <li *ngFor="let sector of sectors">
                                            <a
                                                class="block cursor-pointer w-full text-gray-600 hover:bg-gray-50 hover:text-gray-900 group items-center px-3 py-2 font-medium rounded-md"
                                                (click)="close()"
                                                [routerLink]="[
                                                    '/category',
                                                    sector.slug,
                                                ]"
                                                >{{ sector.name }}</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
